import styled, { createGlobalStyle } from 'styled-components';
import { Modal, Spin, Table } from 'antd';

//群活码 员工活码 企微客户列表的公共样式
const Wrapper = styled.div`
  width: 100%;
  display: flex;
`;

const MarketFilterStyle = styled.div`
  width: 100%;
  padding: 0 16px 0 16px;
  background: #fff;
  margin-bottom: 16px;
  min-height: 144px;
`;

const CommonHeader = styled.div`
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  position: absolute;
  z-index: 200;
  width: 100%;
  .traffic-header-title {
    padding: 0 32px;
    width: 100%;
    height: 64px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .title-name {
    font-size: 20px;
    color: #333333;
    font-weight: bold;
    .loss {
      color: #999999;
      font-size: 14px;
      margin-left: 8px;
      font-weight: 400;
    }
    .retrieve {
      color: #fc8352;
      font-size: 14px;
      font-weight: 400;
    }
    .title-mini{
      cursor: pointer;
      margin-left: 10px;
    }
  }
  div > img {
    margin-left: 5px;
  }
`;

const MainContent = styled.div`
  background: #ecf0f4;
  flex: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow-x: hidden;
  .shadow-tab{
    .ant-tabs-nav{
      box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.1);
    }
    .ant-tabs-tabpane{
      background: #ecf0f4;
    }
  }
  .ant-table-body:hover {
      &::-webkit-scrollbar {
        height: 8px!important;
        width: 4px!important;
    }
    }
  
  .ant-table-body::-webkit-scrollbar {
      height: 0!important;
      width: 0!important;
  }
 .traffic-common-table-class {
    .ant-table-body::-webkit-scrollbar {
      height: 0!important;
      width: 0!important;
    }
  }
`;

const CommonContent = styled.div`
  margin-top: 64px;
  height: 100%;
  padding: 0 16px 0 16px;
  .popconfirm{
    .ant-popover-arrow{
      border-top-color: #fff;
      border-right-color: transparent;
      border-bottom-color: transparent;
      border-left-color: transparent;
      box-shadow: 3px 3px 7px rgb(0 0 0 / 7%);
    }
  }
`;

const MarketBody = styled.div`
  background: #fff;
  padding: 0 20px;
  .ant-checkbox-indeterminate .ant-checkbox-inner::after {
    top: 50%;
    left: 50%;
    width: 8px;
    height: 8px;
    background-color: #fc8352;
    border: 0;
    transform: translate(-50%, -50%) scale(1);
    opacity: 1;
    content: ' ';
  }
  .ant-checkbox-inner::after {
    position: absolute;
    top: 50%;
    left: 22%;
    display: table;
    width: 5.71428571px;
    height: 9.14285714px;
    border: 2px solid #fc8352;
    border-top: 0;
    border-left: 0;
    border-color: #fff !important;
  }
  .ant-checkbox-disabled{
    .ant-checkbox-inner::after {
      border-color: rgba(0, 0, 0, 0.25) !important;
    }
  }
  .ant-table-column-sorters {
    display: flex;
    justify-content: space-between;
  }
  &.noTop {
    padding: 16px 20px;
    margin: 0 16px 16px 16px;
  }
  .ant-table-cell {
    color: #595959;
  }
`;

const MarketHead = styled.div`
  width: 100%;
  height: 64px;
  background: #fff;
  font-size: 20px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1);
  padding: 18px 32px;
  z-index: 200;
  .title-name {
    .retrieve {
      color: #fc8352;
      font-size: 14px;
      font-weight: 400;
    }
    .title-mini{
      cursor: pointer;
      margin-left: 10px;
    }
  }
`;

const BodyHead = styled.div`
  height: 64px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .headbtn {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  p > span {
    color: #fda173;
  }
  .bheadp {
    margin-top: 10px;
  }
  .ant-select {
    width: 100px;
    margin-left: 10px;
  }
  .namep {
    margin-right: 4px;
  }
  .headbtn > .ant-btn {
    width: 100px;
    height: 32px;
    margin-left: 16px;
  }
  .headbtn > p {
    margin-top: 15px;
  }
  .traffic-select
    .ant-select:not(.ant-select-customize-input)
    .ant-select-selector {
    border-right: none;
  }
  .ant-select {
    margin-right: -3px;
  }
`;

const BodyFoot = styled.div`
  height: 60px;
  background: #fff;
`;

const WhiteBackground = createGlobalStyle`
  body {
    .white-background .ant-tooltip-inner{
      font-size: 14px;
      font-weight: 400;
      color: #999999;
      width: 360px;
    }
    //显示拖拽样式
    .react-resizable {
      position: relative;
    }
    .react-resizable-handle {
      position: absolute;
      width: 10px;
      height: 100%;
      bottom: 0;
      right: -5px;
      cursor: col-resize;
      z-index: 999;
    }
  }
`;
const CustomerFilter = styled.div`
  width: 100%;
  padding: 8px 24px 0 24px;
  background: #fff;
  margin: 24px 0;
  min-height: 218px;
`;
const CodeImg = styled.img`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;
const QrCode = styled.img`
  width: 100px;
  height: 100px;
`;
const LimitLine = styled.div`
  width: 200px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
const StyledModal = styled(Modal)`
  .ant-modal-header {
    padding-top: 0;
    padding-bottom: 0;
    width: 100%;
    .ant-modal-title {
      font-weight: 500;
      color: #595959;
      font-size: 16px;
      height: 48px;
      line-height: 48px;
    }
  }
  .ant-modal-close-x{
    height: 48px;
    width: 48px;
    line-height: 48px;
  }
  .ant-modal-footer{
    display: flex;
    justify-content: flex-end;
    align-items: center;
    button{
      min-width: 65px;
      width: unset;
      height: 32px;
      border-radius: 2px;
      margin-right: 16px;
      margin-left: 0 !important;
      margin-top: 0 !important;
      &:last-child{
        margin-right: 0;
      }
    }
  }
`;

const StyledTable = styled(Table)`
.ant-table-thead{
  th{
    padding-top: 0;
    padding-bottom: 0;
    height: 48px;
    font-weight: 500;
    color: #595959;
  }
}
.ant-table-tbody{
  td{
    box-sizing: border-box;
    padding-top: 5px;
    padding-bottom: 5px;
    height: 40px;
    font-weight: 400;
    color: #595959;
    line-height: 18px;
    font-size: 13px;
  }
}
`
const TooltipWrapper = createGlobalStyle`
  body{
    .ant-tooltip-inner{
      font-size: 14px;
      font-weight: 400;
      color: #999999;
    }
  }
`

const SpinWrapper = createGlobalStyle`
  .spin-center-wrapper{
    .ant-spin-blur::after{
      opacity: 0 !important;
    }
    .ant-spin-container.ant-spin-blur {
      opacity: 1;
    }
    .ant-spin-dot.ant-spin-dot-spin {
    }
    .ant-spin-blur::after{
      opacity: 0;
    }
    .spin-center-content{
      background: rgba(187, 187, 187, .4);
      padding: 50px;
      border-radius: 10px;
    }
  }
`

export {
  Wrapper,
  MainContent,
  MarketFilterStyle,
  MarketBody,
  BodyHead,
  BodyFoot,
  CommonHeader,
  WhiteBackground,
  CustomerFilter,
  CodeImg,
  QrCode,
  LimitLine,
  CommonContent,
  MarketHead,
  StyledModal,
  StyledTable,
  TooltipWrapper,
  SpinWrapper
};
